import { NgModule } from '@angular/core';

import { FeatherIconDirective } from '@core/directives/core-feather-icons/core-feather-icons';
import { RippleEffectDirective } from '@core/directives/core-ripple-effect/core-ripple-effect.directive';
import { DeleteDirective } from 'app/directives/delete.directive';

@NgModule({
  declarations: [RippleEffectDirective, FeatherIconDirective,DeleteDirective],
  exports: [RippleEffectDirective, FeatherIconDirective,DeleteDirective]
})
export class CoreDirectivesModule {}
